export function isPremium(profile) {
  if (!profile) return false;
  return profile.entitlement === 'premium' || profile.isFounder === true;
}

export const FREE_TRIP_LIMIT = 3;

export function isTripCreationBlocked({ premiumGateEnabled, profile, createdTripsCount }) {
  return premiumGateEnabled === true && !isPremium(profile) && createdTripsCount >= FREE_TRIP_LIMIT;
}

export function isMultiCityBlocked({ premiumGateEnabled, profile }) {
  return premiumGateEnabled === true && !isPremium(profile);
}
